










































































import BillingProduct from '@/datatypes/billing/product';
import BillingProductService from '@/services/billing/BillingProductService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    billingProducts: new Array<BillingProduct>(),
    hasNext: true,
    errorMessage: '',
    billingProductSearch: { term: '' as string | (string | null)[] },
    nextPointer: undefined as string | undefined,
    billingProductService: new BillingProductService(),
    showInactive: false,
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      if (this.$route.query.term) {
        this.billingProductSearch.term = this.$route.query.term;
      }

      this.getBillingProducts();
    },

    getListOptions() {
      return {
        term: this.billingProductSearch.term,
        next: this.$route.query.next,
        active: !this.showInactive,
      };
    },

    getQueryListOptions() {
      return {
        term: this.billingProductSearch.term,
        next: this.$route.query.next,
        active: !this.showInactive ? 'true' : 'false',
      };
    },

    switchInactive(value) {
      this.resetProductList();
      this.resetPointer();
      this.showInactive = value;
      this.getBillingProducts();
    },

    resetPointer() {
      this.nextPointer = undefined;
    },

    resetProductList() {
      this.billingProducts = new Array<BillingProduct>();
    },

    concatResponse(data: BillingProduct[]) {
      this.billingProducts = this.billingProducts.concat(data);
    },

    getBillingProducts() {
      const nextPage = this.$route.query.next;

      this.billingProductService.list(this.getListOptions()).then((response) => {
        this.concatResponse(response.data.map(
          (data) => new BillingProduct(camelcaseKeysDeep(data)),
        ));
        if (!nextPage && this.billingProducts.length === 0) {
          this.errorMessage = 'No billing products found.';
        }
        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }
        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.navigateUrl(this.nextPointer);
    },

    navigateUrl(next) {
      const query = this.getQueryListOptions();
      query.next = next;

      this.$router.push({ query }).catch((err) => {
        if (err.name === 'NavigationDuplicated') {
          this.getBillingProducts();
        } else {
          throw err;
        }
      });
    },

    searchProducts() {
      this.billingProducts = [];
      this.nextPointer = undefined;

      this.navigateUrl(undefined);
    },
  },
});
